module.exports = "pegasus_template/assets/background-patterns/iron-grip.png";